import { Component, Injectable, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { GetStagesService } from '@/app/services/get-stages.service';
import { ScrollToTopComponent } from '../../../shared/scroll-to-top/scroll-to-top.component';
import { ProgressService } from '@/app/services/shared/progress.service';
import { PlanSectionsComponent } from '../plan-sections/plan-sections.component';
import { ProjectBriefComponent } from '../project-brief/project-brief.component';
import { TabbedScrollerService } from '@/app/services/tabbed-scroller.service';
@Component({
  selector: 'app-tabbed-scroller',
  standalone: true,
  imports: [
    MatExpansionModule,
    CommonModule,
    MatIconModule,
    ScrollToTopComponent,
    ProjectBriefComponent,
    PlanSectionsComponent,
  ],
  templateUrl: './tabbed-scroller.component.html',
  styleUrl: './tabbed-scroller.component.css',
})
@Injectable({ providedIn: 'root' })
export class TabbedScrollerComponent implements OnInit {
  currentStep = 1;
  projectId!: number | null;
  stages: any;
  isEdit = false;
  Stage1OpenState = false;
  Stage2OpenState = false;
  Stage3OpenState = false;
  hideStage2viewmode = true;
  hideStage3viewmode = true;
  showStage1ViewMode = false;
  showStage2ViewMode = false;
  showStage3ViewMode = false;
  isManualScroll = true;

  constructor(
    private getStagesService: GetStagesService,
    private progressService: ProgressService,
    private tabbedScrollerService: TabbedScrollerService
  ) {}
  ngOnInit() {
    this.tabbedScrollerService.moveToPlanSection$.subscribe((moveToPlan) => {
      if (moveToPlan) {
        this.moveToPlanSection(); // Call the method when state updates
      } else {
        this.currentStep = 1;
      }
    });
    this.stages = this.getStagesService.getStages();
    this.Stage1OpenState = true;
  }
  handleEdit() {
    this.isEdit = true;
  }
  nextStep() {
    if (this.currentStep < 7) {
      this.currentStep++;
    }
  }

  moveToPlanSection() {
    if (this.currentStep < 7) {
      this.currentStep = 4;
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  receiveProjectId(id: number) {
    this.projectId = id;
  }
}
